/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Lines_RunningInputs */

const fr_map_lines_running = /** @type {(inputs: Map_Lines_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes en service`)
};

const en_map_lines_running = /** @type {(inputs: Map_Lines_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines in service`)
};

/**
* | output |
* | --- |
* | "Lines in service" |
*
* @param {Map_Lines_RunningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_lines_running = /** @type {((inputs?: Map_Lines_RunningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Lines_RunningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_lines_running(inputs)
	return en_map_lines_running(inputs)
});